import { Box, Image, Text, Spinner } from "@chakra-ui/react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  BASE_URL_MEDIA,
  BASE_URL_WISHLIST,
} from "../../../../Redux/App/action";
import InvitationBanner from "../../../../assets/InvitationBanner.png";

const InvitationSubCat = () => {
  const [catData, setCatData] = useState([]);
  const [allCat, setAllCat] = useState([]);
  const [catId, setCatId] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const Loader = () => {
    return (
      <Box
        position="fixed"
        top="0"
        left="0"
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        background="rgba(0, 0, 0, 0.5)"
        zIndex="9999"
      >
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="blue.500"
          size="xl"
        />
      </Box>
    );
  };

  const getAllCategory = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${BASE_URL_MEDIA}/config/categories/all?screenTypes=DASHBOARD`,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data",
            Token: 123456,
          },
        },
      );
      if (response.status === 200) {
        setAllCat(response.data);

        for (const category of response.data) {
          if (category.categoryName === "INVITATIONS") {
            setCatId(category.categoryId);
            getCategoryData(category.categoryId);
            break;
          }
        }
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllCategory();
  }, []);

  const getCategoryData = async (categoryId) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${BASE_URL_MEDIA}/config/subcategories/bycategoryid?categoryId=${categoryId}`,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data",
            Token: 123456,
          },
        },
      );
      if (response.status === 200) {
        setCatData(response.data);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  if (loading) {
    return (
      <Box h={"80vh"}>
        <Loader />
      </Box>
    );
  }

  return (
    <Box>
      <Box>
        <Text
          fontSize={{ base: "18px", md: "28px" }}
          className="oswald-font"
          fontWeight="bold"
          css={{
            backgroundImage: "linear-gradient(to left, #553c9a, #b393d3)",
            color: "transparent",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
          }}
        >
          Choose a card category to explore
        </Text>
        <Box
          w={"95%"}
          m={"auto"}
          display={"grid"}
          gridTemplateColumns={{ md: "repeat(3,1fr)", base: "repeat(1,1fr)" }}
          gap={2}
          justifyContent={"center"}
          mb={10}
        >
          {catData &&
            catData.map((el, i) => (
              <Box>
                <Box
                  onClick={() => navigate(`/allinvitaions/${el.subCategoryId}`)}
                  cursor="pointer"
                  margin="auto"
                  mt={10}
                  position="relative" // Add this for relative positioning
                >
                  <Image
                    margin="auto"
                    src={el.imageUrl}
                    key={i}
                    cursor="pointer"
                    fallbackSrc="https://via.placeholder.com/350"
                  />
                  <Text
                    className="hover-text"
                    position="absolute"
                    top="50%"
                    left="50%"
                    transform="translate(-50%, -50%)"
                    color="white"
                    opacity={0} // Initially hidden
                    pointerEvents="none" // Prevents the text from blocking clicks
                    fontSize={{
                      base: "14px",
                      md: "14px",
                      lg: "16px",
                      xl: "18px",
                    }}
                    fontFamily={"Sans serif"}
                    fontWeight={"semibold"}
                  >
                    Click to view more
                  </Text>
                </Box>
                <Text
                  fontSize={{
                    base: "14px",
                    md: "10px",
                    lg: "14px",
                    xl: "16px",
                  }}
                  className="lato-font"
                >
                  {el.subCategoryName} Cards
                </Text>
              </Box>
            ))}
        </Box>
      </Box>
    </Box>
  );
};

export default InvitationSubCat;
